export default "__VITE_ASSET__zLpJio2Y__"